<app-pias-layout>
    <div pias-layout-content>
        <div id="create-new-user-container" class="container-fluid">
            <div id="create-new-user-header">
                <h5 class="page-header">Create New User</h5>
            </div>
            <mat-card appearance="raised" class="pias-card">
                <mat-card-content class="pias-card-content">
                    <form class="row align-items-start" [formGroup]="createNewUserFg">
                        <div class="form-section-title">Account Information</div>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="name" type="text" (keyup)="onNameValueChange()" />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Email Address</mat-label>
                                <input matInput formControlName="email" type="email" />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Contact No</mat-label>
                                <input matInput formControlName="contactNo" type="text" />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>User Role</mat-label>
                                <mat-select formControlName="userRole">
                                    @for(role of this.userRoles; track role) {
                                    <mat-option value="{{role.value}}">{{role.name}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </p>


                        <div class="form-section-title">Password Assignment</div>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Username</mat-label>
                                <input matInput formControlName="username" type="text" />
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0 d-flex flex-column justify-content-between">
                            <span class="h6">Password</span>
                            <span class="pias-fs-10">Auto generate and send to user's email.</span>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Expiry Date</mat-label>
                                <input matInput formControlName="expiryDate" type="text" />
                                <mat-hint>MM/DD/YYYY</mat-hint>
                            </mat-form-field>
                        </p>
                        <p class="col-sm-12 col-md-6 col-lg-3 col-xxl-3 m-0">
                            <mat-form-field class="w-100">
                                <mat-label>Status</mat-label>
                                <mat-select formControlName="userStatus">
                                    @for(status of this.userStatus; track status) {
                                    <mat-option value="{{status.value}}">{{status.name}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </p>

                        <mat-divider class="pias-divider"></mat-divider>

                        <div class="row">
                            <div class="col-2">
                                <button type="button" class="btn-pias-secondary" [routerLink]="'/user/manage-user'">Cancel</button>
                            </div>
                            <div class="col-2">
                                <button type="button" class="btn-pias" [disabled]="this.createNewUserFg.invalid" (click)="createNewUser()">Save</button>
                            </div>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</app-pias-layout>